export default __webpack_public_path__ + "static/media/martinize_elastic_bond.78e97e48.png";